export const createBoundary = (name, element, params = {}) => {
    return { name, element, params };
};

export default createBoundary;
